<template>
  <div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small-12">
        <p>
          <router-link to="/view-tutor-groups" class="button">
            Send Email
          </router-link>
        </p>
      </div>
    </div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small-12">
        <h4>Emails which have been sent to this person:</h4>
        <table class="sent-email-table">
          <thead>
            <tr>
              <th>Sent by</th>
              <th>Message</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(email, index) in sentEmails"
              :key="`sm_${index}`">
              <td>{{ email.created_by_user.first_name }} {{ email.created_by_user.last_name }}</td>
              <td><div v-html="email.message"></div></td>
              <td>{{ email.created | tinyDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'SentEmails',
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    learnerId() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      sentEmails: [],
    };
  },
  methods: {
    getSentEmails() {
      const learnerId = this.$route.params.id;
      axios.get(`/sentEmails/getForUser/${learnerId}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}`)
        .then((response) => {
          this.sentEmails = response.data.emails;
        });
    },
  },
  mounted() {
    this.getSentEmails();
  },
};
</script>

<style lang="scss" scoped>
.sent-email-table {
  border-collapse: collapse;
  width: 100%;
  tr th, tr td {
    border: 1px solid #333;
    padding: 5px;
  }
}

</style>
